import { Button } from '@/shared/ui/button';
import { ru } from '@/shared/i18n/ru';
import { cn } from '@/shared/lib/cn';
import { Illustration } from '@/shared/ui/Illustration';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ title = ru.states.errorTitle, description, onRetry, className }: ErrorStateProps) {
  return (
    <div className={cn('flex flex-col items-center gap-3 rounded-lg border border-ink-200 px-6 py-12 text-center', className)}>
      <Illustration name="cat-sleeping" size={88} />
      <div className="text-lg font-semibold text-ink-900">{title}</div>
      {description && <p className="max-w-sm text-sm text-ink-500">{description}</p>}
      {onRetry && (
        <Button variant="secondary" onClick={onRetry} className="mt-2">
          {ru.states.errorRetry}
        </Button>
      )}
    </div>
  );
}
